export default "__VITE_ASSET__68d6ee77__"